import { useContext } from 'react';
import SessionContext from '../../../../library/Core/SessionContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { Button } from 'react-bootstrap';
import { isEmpty } from '../../../../library/Core/SmartFunctions';
import { axiosClient } from '../../../../library/Service/axiosClient';

const BasLayout = (props: any) => {
    const {setUrl , setOpenBookASession , setisMarkedMissed , basData} = props.data;
    const { sessionState } = useContext(SessionContext);
    const { state, dispatch } = useContext(SmartContext);
    const isCounsellor = sessionState?.isCounsellor == true ? 1 : 0;
    const counsellorData = !isEmpty(basData) ? basData[0]?.admin_additional_info : {}
    const appointmentFrom = !isEmpty(basData) ? new Date(new Date(basData[0].appointment_from).getTime() + 330 * 60000) : new Date();
    const appointmentTo = !isEmpty(basData) ? new Date(new Date(basData[0].appointment_to).getTime() + 330 * 60000) : new Date();
    
    const handleBook = () => {
        const text = isCounsellor ? 'Invite from Counsellor' : sessionState?.userTypeCode == 'SUPER_ADMIN' ? 'Invite from Co-ordinator' : 'Looking forward';
        setUrl(`${process.env.REACT_APP_CALENDLY_URL}?name=${state?.data?.firstName + ' ' + state?.data?.lastName}&email=${state?.data?.registeredEmailId}&a1=${text}&hide_gdpr_banner=true`);
        setOpenBookASession(true);
    }

    const handleReschedule = () => {
        setUrl(basData[0]?.reschedule_url ?? '');
        setOpenBookASession(true);
    }
    
    const handleCancel = () => {
        setUrl(basData[0]?.cancel_url ?? '');
        setOpenBookASession(true);
    }

    const handleMissed = () => {
        axiosClient().post(`${process.env.REACT_APP_BAS_API}/counsellorsession/session-status-update`, {id: basData[0]?.id, status:'MISSED'})
        .then((response) => {
            alert(response.data?.message || "Successfully marked as Missed");
            setisMarkedMissed(true);
        })
        .catch((error) => {
            console.error("Error marking session as missed:", error);
        });
    }

    const handleCompleted = () => {
        axiosClient().post(`${process.env.REACT_APP_BAS_API}/counsellorsession/session-status-update`, {id: basData[0]?.id, status:'COMPLETED'})
        .then((response) => {
            alert(response.data?.message || "Successfully marked as Completed");
            setisMarkedMissed(true);
        })
        .catch((error) => {
            console.error("Error marking session as Completed:", error);
        });
    }

    return (
        <>
            <div className="main-wrap max-1140 mx-auto">
                <div className="w-100 p-4">
                    <div className="row g-3 align-items-center">
                        <div className="col-12">
                            <div className="row g-3 align-items-center">
                                <div className="col">
                                    <h1 className="font-24 font-600 mb-0">Session Details</h1>
                                </div>
                                <div className="col-md-auto">
                                    <div className="row g-2 align-item-center">
                                        {(isCounsellor && (basData?.length > 0) && ['SCHEDULED'].includes(basData[0]?.counselling_status) && (new Date(appointmentFrom).getTime() < new Date().getTime())) ? (
                                            (<div className="col-auto">
                                                <Button className="btn-border-gray height-40" onClick={handleCompleted}>
                                                    <span>Mark as Completed</span>
                                                </Button>
                                            </div>)
                                        ) : null}

                                        {(isCounsellor && (basData?.length > 0) && ['SCHEDULED'].includes(basData[0]?.counselling_status) && (new Date(appointmentFrom).getTime() < new Date().getTime())) ? (
                                            (<div className="col-auto">
                                                <Button className="btn-border-gray height-40" onClick={handleMissed}>
                                                    <span>Mark as Missed</span>
                                                </Button>
                                            </div>)
                                        ) : null}

                                        {(basData && !['SCHEDULED','COMPLETED'].includes(basData[0]?.counselling_status) && ((new Date(appointmentTo).getTime() < new Date().getTime()) || ['CANCELLED'].includes(basData[0]?.counselling_status))) ? (
                                            <div className="col-auto">
                                                <Button className="btn-green" onClick={handleBook}>
                                                    <span>Book new Session</span>
                                                </Button>
                                            </div>
                                        ):null}

                                        {(sessionState?.userTypeCode == 'SUPER_ADMIN' && basData?.length > 0 && ['SCHEDULED'].includes(basData[0]?.counselling_status) && ((new Date(appointmentFrom).getTime() - new Date().getTime()) > 60 * 60 * 1000)) ? (
                                            <div className="col-auto">
                                                <Button className="btn-border-gray height-40" onClick={handleCancel}>
                                                    <span>Cancel Session</span>
                                                </Button>
                                            </div>
                                        ):null}

                                        {(sessionState?.userTypeCode == 'SUPER_ADMIN' && basData?.length > 0 && ['SCHEDULED'].includes(basData[0]?.counselling_status) && ((new Date(appointmentFrom).getTime() - new Date().getTime()) > 60 * 60 * 1000)) ? (
                                            <div className="col-auto">
                                                <Button className="btn-green" onClick={handleReschedule}>
                                                    <span>Reschedule Session</span>
                                                </Button>
                                            </div>
                                        ):null}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <hr className="mt-0" />
                        </div>

                        <div className="col-12">
                            <div className="row g-3 align-items-center">
                                {!isEmpty(basData) && <div className="col-sm-auto">
                                    <div className="counsellor-img-placeholder d-flex justify-content-center align-items-end">
                                        <img
                                            src={basData[0]?.profile_picture_file_path ? basData[0]?.profile_picture_file_path : "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/dummy_male.svg"}
                                            width={50}
                                            alt=""
                                        />
                                    </div>
                                </div>}
                                {!isEmpty(basData) && <div className="col-sm">
                                    <div>
                                        <p className="font-18 font-500 mb-0">
                                            <b>{basData[0]?.counsellor_first_name} {basData[0]?.counsellor_last_name}</b>
                                        </p>
                                        <p className="font-16 mb-0">{counsellorData?.title}</p>
                                        <ul className="list-inline d-flex mb-0">
                                        {Array.from({ length: counsellorData?.rating || 0 }).map((_, i) => (
                                            <li key={i}>
                                                <img src="https://www.univariety.xyz/prototype/bas/images/star.svg" alt="star" />
                                            </li>
                                        ))}
                                        </ul>
                                    </div>
                                </div>}

                                {!isEmpty(basData) && (<div className="col-md-6">
                                    <div className="session-details bg-success p-2 bg-opacity-25 p-4 rounded-2">
                                            <div className="session-data">
                                                <span style={basData[0]?.counselling_status != 'SCHEDULED' ? { textDecoration: 'line-through' } : {}}>{new Date(appointmentFrom).toLocaleString(
                                                    'en-IN',
                                                    { timeZone: 'Asia/Kolkata' }
                                                )}{' '}
                                                To{' '}
                                                {new Date(appointmentTo).toLocaleString(
                                                    'en-IN',
                                                    { timeZone: 'Asia/Kolkata' }
                                                )}</span>
                                                {sessionState?.isCounsellor==true ? <>
                                                <div className="session-link"><span>Session Link : </span>{basData[0]?.counselling_status != 'SCHEDULED' ? <span>{basData[0]?.counselling_status}</span> : <span><a href={basData[0]?.appointment_link} target='_blank'>Click Here</a></span>}</div>
                                                <div className="session-with"><span>Student Email : </span><span><a href={`mailto:${basData[0]?.student_email}`}>{basData[0]?.student_email}</a></span></div>
                                                </> 
                                                : <>
                                                <div className="session-link"><span>Session Link : </span>{basData[0]?.counselling_status != 'SCHEDULED' ? <span>{basData[0]?.counselling_status}</span> : <span><a href={basData[0]?.session_link} target='_blank'>Click Here</a></span>}</div>
                                                <div className="session-with"><span>Counsellor Email : </span><span><a href={`mailto:${basData[0]?.counsellor_email}`}>{basData[0]?.counsellor_email}</a></span></div>
                                                </>}
                                            </div>
                                        
                                    </div>
                                </div>)}
                            </div>
                        </div>

                        {!isEmpty(basData) && <div className="col-12">
                            <div className="row g-3">
                                <div className="col-md-3 col-sm-6">
                                    <div className="shadow p-3 h-100">
                                        <div className="font-16 font-600 text-dark-blue">Experience</div>
                                        <div className="font-16 font-500">{counsellorData?.experience}</div>
                                    </div>
                                </div>

                                <div className="col-md-3 col-sm-6">
                                    <div className="shadow p-3 h-100">
                                        <div className="font-16 font-600 text-dark-blue">Expertise</div>
                                        <div className="font-16 font-500">{counsellorData?.expertise}</div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-sm-12">
                                    <div className="shadow p-3 h-100">
                                        <div className="font-16 font-600 text-dark-blue">Qualification</div>
                                        {counsellorData?.qualification.map((qualificationData: any) => (
                                            <div className="font-16 font-500">{qualificationData}</div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {!isEmpty(basData) && <div className="col-12">
                            <p className="font-18 mt-2">
                                {counsellorData?.summary}
                            </p>
                        </div>}

                        {isEmpty(basData) && <div className="col-12">
                            <div className='session-not-found d-flex flex-column justify-content-center align-items-center '>
                                <i className="bi bi-calendar2-x"></i>                                
                                <h2 className='font-28 font-600'>No Session available</h2>
                                <p className='font-18 text-center max-700'>As of now there are no session booked. You can reach out to our support team at <a href="mailto:care@univariety.com">care@univariety.com</a> and they will provide the necessary support in this regard, and help you book a session.</p>
                                    <div className="col-auto">
                                        <Button className="btn-green" onClick={handleBook}>
                                            <span>Book new Session</span>
                                        </Button>
                                    </div>
                            </div>
                        </div>}
                    </div>
                </div>

                {props.children}
            </div>
        </>
    );
};

export default BasLayout;
